import { resolveApiBase } from './access';

const PUBLIC_PATHS = new Set(['/', '/about', '/portfolio', '/contact', '/privacy', '/terms', '/foundation']);
export function recordWebsiteEvent(event, company = '') {
  try {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (!PUBLIC_PATHS.has(path) || localStorage.getItem('jmh_admin_token') || localStorage.getItem('jmh-analytics-opt-out') === '1' || navigator.doNotTrack === '1' || navigator.globalPrivacyControl) return;
    fetch(`${resolveApiBase(process.env.REACT_APP_BACKEND_URL)}/public/analytics`, {
      method:'POST', credentials:'omit', keepalive:true,
      headers:{'Content-Type':'application/json'}, body:JSON.stringify({event,path,company}),
    }).catch(() => {});
  } catch (_) { /* Statistics never interfere with a visitor's task. */ }
}
export function companyForLink(href) {
  const url = new URL(href, window.location.origin);
  if (url.hostname === 'mac.nirvalife.com') return 'mac';
  if (url.hostname === 'nirvalife.com') return 'nirva-life';
  if (url.hostname === 'stewardandstone.jennaemichelle.com') return 'steward-stone';
  if (url.hostname === 'strategicassets.jennaemichelle.com') return 'strategic-assets';
  if (url.hostname === 'foundation.jennaemichelle.com' || (url.origin === window.location.origin && url.pathname === '/foundation')) return 'foundation';
  return '';
}
